import styled from "styled-components";
import theme from "../../style/theme";

interface AsteriskProps {
    color?: string;
    margin?: string;
}

const Asterisk = styled.span<AsteriskProps>`
  color: ${props => props.color || theme.palette.primitives.red600};
  margin: ${props => props.margin || '0 0 0 2px'};
  &::after {
    content: '*';
  }
`;

export default Asterisk;
